import axios from "axios"
axios.defaults.headers.post["Content-Type"] = "application/json"
axios.defaults.headers.post["Accept"] = "application/json"

axios.interceptors.response.use(null,error=>{
    const ExpectedError = error.response && error.response.status >= 400 && error.response.status <500
    // if(!ExpectedError){
    //     toast.error("مشکلی از سمت سرور پیش امده است.",{

    //     })
    // }
    // console.log(ExpectedError);
    return Promise.reject(error)
})

export default {
    get : axios.get,
    post : axios.post,
    put : axios.put,
    delete : axios.delete,
}